import { ENV } from '@/config/env';

export type LocationMapScheme = 'dark' | 'light';

/**
 * Public gateway URL of a business's Location map (ADR 0009). `version` (the
 * business's updatedAt) is ignored by the gateway; it only makes the client's
 * disk cache refetch after the business is edited.
 */
export function locationMapUrl(businessId: string, scheme: LocationMapScheme, version: number): string {
  return `${ENV.API_URL}/api/v1/public/maps/business/${encodeURIComponent(businessId)}?scheme=${scheme}&v=${version}`;
}
